import { IEnvironment } from '@treetop/shared/model';

export const Environment: IEnvironment = {
  production: true,
  EnableOffline: true,
  Version: '25-12-01',
  ApiBackendBaseUrl: '#{ApplicationApiBackendUrl}#',
  PublicLinkBaseUrl: '#{PublicLinkBaseUrl}#',
  PublicLinkClinicalUrl: '#{PublicLinkClinicalUrl}#',
  WorkflowFrontendBaseUrl: '#{WorkflowFrontendBaseUrl}#',
  HubUrl: '#{ApplicationHubUrl}#',
  ApplicationInsightsConnectionString: '#{ApplicationInsightsConnectionString}#',
  ApplicationInsightsEndpoint: '#{ApplicationInsightsEndpoint}#',
  AuthB2C: {
    defaultScopeName: '#{DefaultScopeNameB2C}#',
    tenant: '#{TenantB2C}#',
    tenantId: '#{TenantIdB2C}#',
    clientId: '#{ClientIdB2C}#',
    instance: '#{InstanceUrlB2C}#',
    signupsigninflow: '#{UserFlowB2C}#',
  },
};
